var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmiPointLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1060_214980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4936 51.2963C17.6793 47.9395 11.9588 42.2567 7.94812 34.8766C3.73632 27.1194 1.49841 17.5517 1.48584 7.21704C2.4665 6.53812 11.5061 0.641602 24.4936 0.641602C37.4936 0.641602 46.5207 6.55069 47.5139 7.21704C47.5013 17.5517 45.2634 27.1194 41.039 34.8766C37.041 42.2567 31.3205 47.9395 24.4936 51.2963Z",
    fill: "url(#paint0_linear_1060_214980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4937 52.0001L24.2171 51.8618C17.2896 48.4421 11.4685 42.6713 7.39502 35.1781C3.13293 27.3202 0.869872 17.652 0.844727 7.21676V6.88987L1.12132 6.70128C2.12713 6.02237 11.3176 0.0126953 24.4937 0.0126953C37.6823 0.0126953 46.8602 6.00979 47.866 6.70128L48.1426 6.88987V7.21676C48.13 17.652 45.867 27.3202 41.5923 35.1781C37.5188 42.6713 31.7103 48.4421 24.7703 51.8618L24.4937 52.0001ZM2.11455 7.55622C2.17742 17.652 4.39018 26.9934 8.51397 34.5872C12.4115 41.7535 17.9308 47.2854 24.5062 50.6046C31.0691 47.2729 36.601 41.7409 40.4859 34.5746C44.6097 26.9934 46.8225 17.652 46.8853 7.54364C45.0623 6.36183 36.5004 1.25738 24.4937 1.25738C12.4995 1.26995 3.93757 6.36183 2.11455 7.55622Z",
    fill: "url(#paint1_linear_1060_214980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6493 35.9697C13.92 35.9697 13.2034 35.6931 12.6376 35.1399C11.5313 34.0335 11.5313 32.2357 12.6376 31.1293L22.57 21.197C23.6763 20.0906 25.4742 20.0906 26.5806 21.197L36.3494 30.9658C37.4433 32.0596 37.4558 33.8324 36.3872 34.9388C35.2808 36.0829 33.4075 36.0451 32.2885 34.9262L26.2914 28.9291C25.3359 27.9736 23.8021 27.9736 22.8591 28.9291L16.6483 35.1399C16.0951 35.6931 15.3659 35.9697 14.6493 35.9697Z",
    fill: "url(#paint2_radial_1060_214980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6492 36.096C13.8572 36.096 13.1154 35.7817 12.5496 35.2285C11.9839 34.6753 11.6821 33.921 11.6821 33.1289C11.6821 32.3368 11.9964 31.5951 12.5496 31.0293L22.4819 21.097C23.6386 19.9403 25.5119 19.9403 26.6686 21.097L36.4374 30.8659C37.569 31.9974 37.5941 33.8581 36.4752 35.0148C35.9345 35.5806 35.1928 35.8949 34.4007 35.8949C34.3881 35.8949 34.3756 35.8949 34.3756 35.8949C33.5583 35.8949 32.7788 35.568 32.2005 35.0022L26.2034 29.0051C25.3108 28.1125 23.8398 28.1125 22.9471 29.0051L16.7363 35.216C16.1831 35.7943 15.4413 36.096 14.6492 36.096ZM24.5815 20.4935C23.8901 20.4935 23.1986 20.7575 22.6705 21.2856L12.7382 31.2179C12.2227 31.7334 11.9462 32.4123 11.9462 33.1289C11.9462 33.8581 12.2227 34.537 12.7382 35.0399C13.2537 35.5554 13.9326 35.832 14.6492 35.832C15.3785 35.832 16.0574 35.5554 16.5603 35.0399L22.7711 28.8291C23.2489 28.3513 23.8901 28.0748 24.5815 28.0748C25.273 28.0748 25.9017 28.3388 26.392 28.8291L32.3891 34.8262C32.9171 35.3543 33.6338 35.6434 34.3881 35.6434C34.4007 35.6434 34.4007 35.6434 34.4133 35.6434C35.1425 35.6308 35.8214 35.3543 36.3117 34.8388C37.3301 33.7827 37.3175 32.0854 36.274 31.0419L26.5051 21.273C25.9645 20.7575 25.273 20.4935 24.5815 20.4935Z",
    fill: "url(#paint3_linear_1060_214980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6493 22.1152C13.92 22.1152 13.2034 21.8386 12.6376 21.2854C11.5313 20.179 11.5313 18.3812 12.6376 17.2748L22.57 7.34248C23.6763 6.2361 25.4742 6.2361 26.5806 7.34248L36.3494 17.1113C37.4433 18.2052 37.4558 19.9779 36.3872 21.0843C35.2808 22.2284 33.4075 22.1906 32.2885 21.0717L26.2914 15.0746C25.3359 14.1191 23.8021 14.1191 22.8591 15.0746L16.6483 21.2854C16.0951 21.8386 15.3659 22.1152 14.6493 22.1152Z",
    fill: "url(#paint4_radial_1060_214980)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6492 22.2406C13.8572 22.2406 13.1154 21.9262 12.5496 21.3731C11.9839 20.8199 11.6821 20.0655 11.6821 19.2734C11.6821 18.4814 11.9964 17.7396 12.5496 17.1738L22.4819 7.24153C23.6386 6.08486 25.5119 6.08486 26.6686 7.24153L36.4374 17.0104C37.569 18.1419 37.5941 20.0027 36.4752 21.1593C35.9345 21.7251 35.1928 22.0394 34.4007 22.0394C33.5709 22.052 32.7788 21.7251 32.2005 21.1468L26.2034 15.1497C25.3108 14.257 23.8398 14.257 22.9471 15.1497L16.7363 21.3731C16.1831 21.9262 15.4413 22.2406 14.6492 22.2406ZM24.5815 6.63805C23.8901 6.63805 23.1986 6.90207 22.6705 7.43012L12.7382 17.3624C12.2227 17.8779 11.9462 18.5568 11.9462 19.2734C11.9462 19.9901 12.2227 20.6816 12.7382 21.1845C13.2537 21.6999 13.9326 21.9765 14.6492 21.9765C15.3785 21.9765 16.0574 21.6999 16.5603 21.1845L22.7711 14.9736C23.2489 14.4959 23.8901 14.2193 24.5815 14.2193C25.273 14.2193 25.9017 14.4833 26.392 14.9736L32.3891 20.9707C32.9171 21.4988 33.6589 21.8005 34.4133 21.788C35.1425 21.7754 35.8214 21.4988 36.3117 20.9833C37.3301 19.9272 37.3175 18.2299 36.274 17.1864L26.5051 7.41754C25.9645 6.90207 25.273 6.63805 24.5815 6.63805Z",
    fill: "url(#paint5_linear_1060_214980)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1060_214980",
    x1: 1.47955,
    y1: 25.9673,
    x2: 47.5154,
    y2: 25.9673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7982E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#B47E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2623,
    stopColor: "#F8DE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3672,
    stopColor: "#F8DE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#F6DB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4975,
    stopColor: "#DEBA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6188,
    stopColor: "#CCA036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7385,
    stopColor: "#BF8D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8561,
    stopColor: "#B78214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9689,
    stopColor: "#B47E10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1060_214980",
    x1: 0.85051,
    y1: 26.0032,
    x2: 48.1446,
    y2: 26.0032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.076968,
    stopColor: "#F8DE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1632,
    stopColor: "#E0BC55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2487,
    stopColor: "#CDA137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3325,
    stopColor: "#BF8D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4136,
    stopColor: "#B78214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4892,
    stopColor: "#B47E10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#B78214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6318,
    stopColor: "#BF8D21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7059,
    stopColor: "#CCA036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#DEBA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8562,
    stopColor: "#F6DB78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    stopColor: "#F8DE7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2A5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1060_214980",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4974 28.1694) scale(10.5317 10.5317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1060_214980",
    x1: 11.6841,
    y1: 28.1706,
    x2: 37.305,
    y2: 28.1706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F1A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0879397,
    stopColor: "#C0802D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#F8C957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2588,
    stopColor: "#FFEBC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3351,
    stopColor: "#FEEAC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    stopColor: "#FBE5BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3822,
    stopColor: "#F7DDB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3981,
    stopColor: "#F0D1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4117,
    stopColor: "#E6C18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4237,
    stopColor: "#DBAE6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CE984F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4434,
    stopColor: "#C0802D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5387,
    stopColor: "#402605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5561,
    stopColor: "#5F3908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5581,
    stopColor: "#68410C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#8B5E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5765,
    stopColor: "#A77629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5867,
    stopColor: "#BD8933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5977,
    stopColor: "#CD963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6103,
    stopColor: "#D69E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6281,
    stopColor: "#D9A040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7315,
    stopColor: "#FFEAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7772,
    stopColor: "#FFE9C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8033,
    stopColor: "#FEE7B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#FDE3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8431,
    stopColor: "#FCDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#F8CB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8786,
    stopColor: "#F8C957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8803,
    stopColor: "#F0C254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C39B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#9B782F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    stopColor: "#7A5B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#5E4315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9398,
    stopColor: "#49310B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9549,
    stopColor: "#3A2405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9727,
    stopColor: "#321C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1A00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1060_214980",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4974 14.3083) scale(10.5317 10.5317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E5653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1060_214980",
    x1: 11.6841,
    y1: 14.3087,
    x2: 37.305,
    y2: 14.3087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F1A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0879397,
    stopColor: "#C0802D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#F8C957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2588,
    stopColor: "#FFEBC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3351,
    stopColor: "#FEEAC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    stopColor: "#FBE5BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3822,
    stopColor: "#F7DDB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3981,
    stopColor: "#F0D1A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4117,
    stopColor: "#E6C18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4237,
    stopColor: "#DBAE6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4343,
    stopColor: "#CE984F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4434,
    stopColor: "#C0802D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5387,
    stopColor: "#402605"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5561,
    stopColor: "#5F3908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5581,
    stopColor: "#68410C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    stopColor: "#8B5E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5765,
    stopColor: "#A77629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5867,
    stopColor: "#BD8933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5977,
    stopColor: "#CD963A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6103,
    stopColor: "#D69E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6281,
    stopColor: "#D9A040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7315,
    stopColor: "#FFEAC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7772,
    stopColor: "#FFE9C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8033,
    stopColor: "#FEE7B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8245,
    stopColor: "#FDE3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8431,
    stopColor: "#FCDD98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FAD57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#F8CB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8786,
    stopColor: "#F8C957"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8803,
    stopColor: "#F0C254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8908,
    stopColor: "#C39B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    stopColor: "#9B782F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9138,
    stopColor: "#7A5B20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9263,
    stopColor: "#5E4315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9398,
    stopColor: "#49310B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9549,
    stopColor: "#3A2405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9727,
    stopColor: "#321C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F1A00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1060_214980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.3607,
    height: 52,
    fill: "white",
    transform: "translate(0.81958)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmiPointLogo);
export default __webpack_public_path__ + "static/media/GMI-point-logo.4cde9637714b0211c856c6323fc2d0d2.svg";
export { ForwardRef as ReactComponent };